export const PROFILE_LOADING = 'PROFILE_LOADING';
export const GET_MY_PROFILE = 'GET_MY_PROFILE';
export const GET_MY_PROFILE_GRANTS = 'GET_MY_PROFILE_GRANTS';